import React from "react";
import { Route } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import PermissionProtectedRoute from "./components/PermissionProtectedRoute"; // Assuming this component exists for permission checks
import ScopeProtectedRoute from "./components/ScopeProtectedRoute";
import { getRequiredScopesForPath } from "./utils/scopeMap";
import Login from "./pages/Login"; // Use the updated Login component
// import Dashboard from './pages/Dashboard'; // Placeholder for dashboard or replace with your actual component
import DashboardHome_v2 from "./pages/DashboardHome_v2"; // Placeholder for dashboard or replace with your actual component
import DashboardHome_v3 from "./pages/DashboardHome_v3"; // Placeholder for dashboard or replace with your actual component
import CorporatePage from "./pages/CorporatePage";
import CorporateStatusList from "./pages/CorporateStatusList";

import ClaimsBatchRegistration from "./pages/Claims/ClaimsBatchRegistration";
import AddClaimsBatch from "./pages/Claims/AddClaimsBatch";
import AddNewBatchRedirectModal from "./pages/Claims/AddNewBatchRedirectModal";
import EditClaimsBatch from "./pages/Claims/EditClaimsBatch";
import ViewClaimsBatch from "./pages/Claims/ViewClaimsBatch";
import ClaimsProcessing from "./pages/Claims/ClaimsProcessing";
import ClaimsUploadQueue from "./pages/Claims/ClaimsUploadQueue";
import ExtractClaimsQueue from "./pages/Claims/ExtractClaimsQueue";
import ClaimsUploadQueueSOA from "./pages/Claims/ClaimsUploadQueueSOA";
import ClaimsAlreadyBatchAutditLogsPage from "./pages/Claims/ClaimsAlreadyBatchAutditLogsPage";
import ClaimsReceivingExcludedLogs from "./pages/Claims/ClaimsReceivingExcludedLogs";
import ClaimsRtpEntry from "./pages/Claims/ClaimsRtpEntry";
import ClaimsRtpReportQueryRequest from "./pages/Claims/ClaimsRtpReportQueryRequest";
import ClaimsRtpApprovals from "./pages/Claims/ClaimsRtpApprovals";
import ClaimsRtpDownloadedFormHistory from "./pages/Claims/ClaimsRtpDownloadedFormHistory";
import PhysicianNotYetEnrolled from "./pages/Claims/PhysicianNotYetEnrolled";
import ClaimsStaleChecker from "./pages/Claims/ClaimsStaleChecker";
import ProcessClaimFullPage from "./pages/Claims/ProcessClaimFullPage";
import ScanLoaDocumentQrFullPage from "./pages/Claims/ScanLoaDocumentQrFullPage";

import FontawesomeIconsDemo from "./pages/FontawesomeIconsDemo";
import TooltipTutorial from "./pages/Tutorial/TooltipTutorial";
import BubbleTooltip from "./pages/Tutorial/BubbleTooltip";
import Chatbox from "./pages/Chatbox";
// Add other page imports as needed based on your project
// Example imports (replace with actual components):
// import ChatbotQueuing from './pages/ChatbotQueuing';
// import Analytics from './pages/Analytics';
// ... other imports ...

import ClaimsBatchEdit from "./pages/SampleAutoScan/ClaimsBatchEdit";
import ReceivedScannedDateUploadingPage from "./pages/Claims/ReceivedScannedDateUploadingPage";

import ProviderTable from "./pages/Provider/ProviderTable";
import ProviderEnrollmentForm from "./pages/Provider/ProviderEnrollmentForm";
import ProviderClaimsSubmissionSettings from "./pages/Provider/ProviderClaimsSubmissionSettings";
import CptTable from "./pages/Cpt/CptTable";
import AddCpt from "./pages/Cpt/AddCpt";
import EditCpt from "./pages/Cpt/EditCpt";
import CptHistory from "./pages/Cpt/CptHistory";
import CptBatchUploadPage from "./pages/Cpt/CptBatchUploadPage";
import CptBatchUploadHistoryPage from "./pages/Cpt/CptBatchUploadHistoryPage";
import CptBatchUploadProcessedPage from "./pages/Cpt/CptBatchUploadProcessedPage";
import IcdTable from "./pages/Icd/IcdTable";
import IcdHistory from "./pages/Icd/IcdHistory";
import EditIcd from "./pages/Icd/EditIcd";
import AddIcd from "./pages/Icd/AddIcd";
import RvuTable from "./pages/Rvu/RvuTable";
import RvuHistory from "./pages/Rvu/RvuHistory";
import AddRvu from "./pages/Rvu/AddRvu";
import EditRvu from "./pages/Rvu/EditRvu";
import PhysicianTable from "./pages/Physician/PhysicianTable";
import PhysicianEnrollmentForm from "./pages/Physician/PhysicianEnrollmentForm";
import EditPhysician from "./pages/Physician/EditPhysician";
import ViewPhysician from "./pages/Physician/ViewPhysician";
import PhysicianBatchUploadPage from "./pages/Physician/PhysicianBatchUploadPage";
import PhysicianBatchUploadHistoryPage from "./pages/Physician/PhysicianBatchUploadHistoryPage";
import PhysicianBatchUploadProcessedPage from "./pages/Physician/PhysicianBatchUploadProcessedPage";
import CorporateTable from "./pages/Corporate/CorporateTable";
import CorporateEnrollmentForm from "./pages/Corporate/CorporateEnrollmentForm";
import CorporateViewModal from "./pages/Corporate/CorporateViewModal";
import CorporateAddFundPage from "./pages/Corporate/CorporateAddFundPage";
import PlanAndCoverageBenefitsTable from "./pages/PlanAndCoverageBenefits/PlanAndCoverageBenefitsTable";
import AddPlanForm from "./pages/PlanAndCoverageBenefits/AddPlanForm";
import RefCoverageMaster from "./pages/ReferenceMasterTables/RefCoverageMaster";
// import CorporatePlansTable from "./pages/PlanAndCoverageBenefits/CorporatePlansTable";
// import PlanForm from "./pages/PlanAndCoverageBenefits/PlanForm";
import PlanCoverageViewer from "./pages/PlanAndCoverageBenefits/PlanCoverageViewer";
import EditPlanForm from "./pages/PlanAndCoverageBenefits/EditPlanForm";
import MemberTable from "./pages/Member/MemberTable";
import MemberViewFullPage from "./pages/Member/MemberViewFullPage";
import AddMemberForm from "./pages/Member/AddMemberForm";
import EditMemberForm from "./pages/Member/EditMemberForm";
import EmployeeIdGeneratorPage from "./pages/Member/EmployeeIdGeneratorPage";
import BannerTable from "./pages/Banner/BannerTable";
import AddBannerForm from "./pages/Banner/AddBannerForm";
import EditBannerForm from "./pages/Banner/EditBannerForm";
import ProviderAccessPage from "./pages/ProviderAccess/ProviderAccessPage";
import ApeSchedulerPage from "./pages/ApeScheduler/ApeSchedulerPage";
import ApeScheduleListPage from "./pages/ApeScheduler/ApeScheduleListPage";
import ApeSchedulerEditPage from "./pages/ApeScheduler/ApeSchedulerEditPage";
import ApeScheduleViewer from "./pages/ApeScheduler/ApeScheduleViewer";
import ActivityLogs from "./pages/ActivityLogs/ActivityLogs";
import ChangelogPage from "./pages/Changelog/ChangelogPage";
import ReportsPage from "./pages/Reports/ReportsPage";
import MessagesPage from "./pages/Messages/MessagesPage";
import ApePdfHistoryPage from "./pages/ApeScheduler/ApePdfHistoryPage";
import SystemSettingsV2 from "./pages/SystemSettingsV2";
import UploadMemberEnrollment from "./pages/Member/UploadMemberEnrollment";
import UploadMemberEnrollmentHistory from "./pages/Member/UploadMemberEnrollmentHistory";
import MemberEnrollmentProcessedHistory from "./pages/Member/MemberEnrollmentProcessedHistory";
import BatchRenewalUploadPage from "./pages/Member/BatchRenewalUploadPage";
import BatchRenewalUploadHistoryPage from "./pages/Member/BatchRenewalUploadHistoryPage";
import BatchRenewalUploadProcessedPage from "./pages/Member/BatchRenewalUploadProcessedPage";
import BatchActivationUploadPage from "./pages/Member/BatchActivationUploadPage";
import BatchActivationUploadHistoryPage from "./pages/Member/BatchActivationUploadHistoryPage";
import BatchActivationUploadProcessedPage from "./pages/Member/BatchActivationUploadProcessedPage";
import BatchDeactivationUploadPage from "./pages/Member/BatchDeactivationUploadPage";
import BatchDeactivationUploadHistoryPage from "./pages/Member/BatchDeactivationUploadHistoryPage";
import BatchDeactivationUploadProcessedPage from "./pages/Member/BatchDeactivationUploadProcessedPage";
import BatchChangePlanUploadPage from "./pages/Member/BatchChangePlanUploadPage";
import BatchChangePlanUploadHistoryPage from "./pages/Member/BatchChangePlanUploadHistoryPage";
import BatchChangePlanUploadProcessedPage from "./pages/Member/BatchChangePlanUploadProcessedPage";
import BatchTextAlertMobileUpdateUploadPage from "./pages/Member/BatchTextAlertMobileUpdateUploadPage";
import BatchTextAlertMobileUpdateUploadHistoryPage from "./pages/Member/BatchTextAlertMobileUpdateUploadHistoryPage";
import BatchTextAlertMobileUpdateUploadProcessedPage from "./pages/Member/BatchTextAlertMobileUpdateUploadProcessedPage";
import TransactionList from "./pages/Transaction/TransactionList";
import TransactionDetailsPage from "./pages/Transaction/TransactionDetailsPage";
import GenerateLoaTransaction from "./pages/Transaction/GenerateLoaTransaction";
import LoaPdfGenerationSpecsPage from "./pages/Transaction/LoaPdfGenerationSpecsPage";
import LoaIssuerLookupPage from "./pages/Transaction/LoaIssuerLookupPage";
import TrackerPage from "./pages/Tracker/TrackerPage";
import ProfilePage from "./pages/ProfilePage";
import PasswordChangePage from "./pages/PasswordChangePage";
import AdmissionDischargeTable from "./pages/Transaction/AdmissionDischargeTable";
import AdmissionVerificationTable from "./pages/Transaction/AdmissionVerificationTable";
import ProcessDischargePage from "./pages/Transaction/ProcessDischargePage";
import SystemUsers from "./pages/SystemUsers/SystemUsers";
import UploadS3PublicShareTokenPage from "./pages/SystemAdmin/UploadS3PublicShareTokenPage";
import DynamicTableUpdatePage from "./pages/SystemAdmin/DynamicTableUpdatePage";
import CurlRequestResponseLogsPage from "./pages/SystemAdmin/CurlRequestResponseLogsPage";
import BackendModulePage from "./pages/SystemAdmin/BackendModulePage";
import BackendModuleSpecsPage from "./pages/SystemAdmin/BackendModuleSpecsPage";
import BackendLogsPage from "./pages/SystemAdmin/BackendLogsPage";
import ExtractClaimsLogsPage from "./pages/SystemAdmin/ExtractClaimsLogsPage";
import QueriesPlaceholderPage from "./pages/QueriesPlaceholderPage";
import ReimbursementList from "./pages/Reimbursement/ReimbursementList";
import ReimbursementAdd from "./pages/Reimbursement/ReimbursementAdd";
import DetailedPaymentReportPage from "./pages/ProviderPayment/DetailedPaymentReportPage";
import DetailedPaymentReportAllPage from "./pages/ProviderPayment/DetailedPaymentReportAllPage";
import DetailedPaymentReportFullViewPage from "./pages/ProviderPayment/DetailedPaymentReportFullViewPage";
import BatchAddHolidayListPage from "./pages/ProviderPayment/BatchAddHolidayListPage";
import BatchAddHolidayUploadPage from "./pages/ProviderPayment/BatchAddHolidayUploadPage";
import BatchAddHolidayUploadHistoryPage from "./pages/ProviderPayment/BatchAddHolidayUploadHistoryPage";
import BatchAddHolidayUploadProcessedPage from "./pages/ProviderPayment/BatchAddHolidayUploadProcessedPage";
import DprUploadValidationCsvPage from "./pages/ProviderPayment/DprUploadValidationCsvPage";
import DprUploadValidationCsvHistoryPage from "./pages/ProviderPayment/DprUploadValidationCsvHistoryPage";
import DprUploadValidationCsvProcessedPage from "./pages/ProviderPayment/DprUploadValidationCsvProcessedPage";
import DprUploadValidationAiSummaryHistoryPage from "./pages/ProviderPayment/DprUploadValidationAiSummaryHistoryPage";
import DprValidationDashboardPage from "./pages/ProviderPayment/DprValidationDashboardPage";
import DprValidationSupportPage from "./pages/ProviderPayment/DprValidationSupportPage";
import FindDataUsingPrnPage from "./pages/ProviderPayment/FindDataUsingPrnPage";
import CreditFilePage from "./pages/ProviderPayment/CreditFilePage";
import CreditAdviseUploadPage from "./pages/ProviderPayment/CreditAdviseUploadPage";
import CreditAdviseUploadHistoryPage from "./pages/ProviderPayment/CreditAdviseUploadHistoryPage";
import CreditAdviseUploadProcessedPage from "./pages/ProviderPayment/CreditAdviseUploadProcessedPage";
import SettlementEmailOutboxPage from "./pages/ProviderPayment/SettlementEmailOutboxPage";
import ProviderBankValidationPage from "./pages/ProviderPayment/ProviderBankValidationPage";
import SettlementListPage from "./pages/ProviderPayment/SettlementListPage";
import SettlementHistoryPage from "./pages/ProviderPayment/SettlementHistoryPage";
import BatchPrintPisAndForm2307Page from "./pages/ProviderPayment/BatchPrintPisAndForm2307Page";
import ProviderDeliveryAddressLabelPage from "./pages/ProviderPayment/ProviderDeliveryAddressLabelPage";
import SettlementBatchUploadPage from "./pages/ProviderPayment/SettlementBatchUploadPage";
import SettlementBatchUploadHistoryPage from "./pages/ProviderPayment/SettlementBatchUploadHistoryPage";
import SettlementBatchUploadProcessedPage from "./pages/ProviderPayment/SettlementBatchUploadProcessedPage";
import SettlementPdfRegenerationBatchUploadPage from "./pages/ProviderPayment/SettlementPdfRegenerationBatchUploadPage";
import SettlementPdfRegenerationBatchHistoryPage from "./pages/ProviderPayment/SettlementPdfRegenerationBatchHistoryPage";
import SettlementPdfRegenerationBatchProcessedPage from "./pages/ProviderPayment/SettlementPdfRegenerationBatchProcessedPage";
import CheckStatusBatchUploadPage from "./pages/ProviderPayment/CheckStatusBatchUploadPage";
import CheckStatusBatchUploadHistoryPage from "./pages/ProviderPayment/CheckStatusBatchUploadHistoryPage";
import CheckStatusBatchUploadProcessedPage from "./pages/ProviderPayment/CheckStatusBatchUploadProcessedPage";
import DepositSlipBatchUploadPage from "./pages/ProviderPayment/DepositSlipBatchUploadPage";
import DepositSlipBatchUploadHistoryPage from "./pages/ProviderPayment/DepositSlipBatchUploadHistoryPage";
import DepositSlipBatchUploadProcessedPage from "./pages/ProviderPayment/DepositSlipBatchUploadProcessedPage";
import DepoOrBatchUploadPage from "./pages/ProviderPayment/DepoOrBatchUploadPage";
import DepoOrBatchUploadHistoryPage from "./pages/ProviderPayment/DepoOrBatchUploadHistoryPage";
import DepoOrBatchUploadProcessedPage from "./pages/ProviderPayment/DepoOrBatchUploadProcessedPage";

import GoogleSignInButton from './pages/GoogleSignInButton';

// Public Routes
export const publicRoutes = (
  <Route
    path="/login"
    element={
      <GoogleReCaptchaProvider reCaptchaKey="6Lfr6dwqAAAAAM40hrOttRrUdRRShlIoC6Qi0NN1">
        <Login />
      </GoogleReCaptchaProvider>
    }
  />
);

{
  /* <Route path="/claims/batches" element={<ClaimsBatchRegistration />} />
        <Route path="/claims/batches/add" element={<AddClaimsBatch />} />
        <Route path="/claims/batches/edit/:id" element={<EditClaimsBatch />} />
        <Route path="/claims/batches/view/:id" element={<ViewClaimsBatch />} /> */
}

// Protected Routes (authentication required)
const baseProtectedRoutes = [
  // users
  { path: "/profile", element: <ProfilePage />, permission: "access_page" },
  {
    path: "/change-password",
    element: <PasswordChangePage />,
    permission: "access_page",
  },

  { path: "/FontawesomeIconsDemo", element: <FontawesomeIconsDemo /> },
  // { path: "/dashboard", element: <Dashboard /> },
  // { path: "/dashboard", element: <DashboardHome_v2 /> },
  { path: "/dashboard", element: <DashboardHome_v3 /> },
  { path: "/reports", element: <ReportsPage /> },
  // { path: "/dashboard", element: <TooltipTutorial /> },
  { path: "/corporate/list", element: <CorporatePage /> },
  { path: "/corporate/status-list", element: <CorporateStatusList /> },

  { path: "/claims/batches", element: <ClaimsBatchRegistration /> },
  // { path: "/claims/batches/add", element: <AddClaimsBatch /> },
  { 
    path: "/claims/batches/add", 
    element: <AddNewBatchRedirectModal /> 
  },
  { path: "/claims/batches/edit/:batchNo", element: <EditClaimsBatch /> },
  { path: "/claims/batches/view/:batchNo", element: <ViewClaimsBatch /> },

  { path: "/claims/receiving", element: <ReceivedScannedDateUploadingPage /> },
  { path: "/claims/receiving/scan-loa-document-qr", element: <ScanLoaDocumentQrFullPage /> },
  { path: "/claims/receiving/excluded-logs", element: <ClaimsReceivingExcludedLogs /> },

  { path: "/claims/processing", element: <ClaimsProcessing /> },
  { path: "/claims/processing/for-processing-view", element: <ProcessClaimFullPage /> },
  { path: "/claims/rtp-entry", element: <ClaimsRtpEntry /> },
  { path: "/claims/rtp-report-query-request", element: <ClaimsRtpReportQueryRequest /> },
  { path: "/claims/rtp-final-approvals", element: <ClaimsRtpApprovals /> },
  { path: "/claims/rtp-approvals", element: <ClaimsRtpApprovals /> },
  { path: "/claims/rtp-downloaded-form-history", element: <ClaimsRtpDownloadedFormHistory /> },
  { path: "/claims/physician-not-yet-enrolled", element: <PhysicianNotYetEnrolled /> },
  { path: "/claims/extract-queue", element: <ExtractClaimsQueue /> },
  { path: "/claims/upload-queue", element: <ClaimsUploadQueue /> },
  { path: "/claims/upload-queue-soa", element: <ClaimsUploadQueueSOA /> },
  { path: "/claims/already-batch-audit-logs", element: <ClaimsAlreadyBatchAutditLogsPage /> },
  { path: "/claims/stale-checker", element: <ClaimsStaleChecker /> },

  // { path: "/aasai", element: <Chatbox /> },
  // Add more protected routes here as needed

  // MEDICAL PROVIDERS
  { path: "/medical/provider", element: <ProviderTable /> },
  {
    path: "/medical/provider-claims-submission-settings",
    element: <ProviderClaimsSubmissionSettings />,
  },
  { path: "/medical/add-new-provider", element: <ProviderEnrollmentForm /> },
  // { path: "/medical/add-new-provider/", element: <ProviderEnrollmentForm /> },
  // Update provider
  {
    path: "/medical/update-provider/:providerCode",
    element: <ProviderEnrollmentForm />,
  },
  { path: "/medical/view-provider/:providerCode", element: <ProviderEnrollmentForm isViewMode /> },

  { path: "/cpt", element: <CptTable /> },
  { path: "/cpt/add-new-cpt", element: <AddCpt /> },
  { path: "/cpt/edit/:cptCode", element: <EditCpt /> },
  { path: "/cpt/view/:cptCode", element: <EditCpt /> },
  { path: "/cpt/history/:cptCode", element: <CptHistory /> },
  { path: "/cpt-batch-upload", element: <CptBatchUploadPage /> },
  {
    path: "/history-cpt-batch-upload",
    element: <CptBatchUploadHistoryPage />,
  },
  {
    path: "/processed-cpt-batch-upload",
    element: <CptBatchUploadProcessedPage />,
  },
  {
    path: "/processed-cpt-batch-upload/:uploadId",
    element: <CptBatchUploadProcessedPage />,
  },

  { path: "/icd", element: <IcdTable /> },
  { path: "/icd/add", element: <AddIcd /> },
  { path: "/icd/edit/:icdCode", element: <EditIcd /> },
  { path: "/icd/view/:icdCode", element: <EditIcd /> },
  { path: "/icd/history/:icdCode", element: <IcdHistory /> },

  { path: "/rvu", element: <RvuTable /> },
  { path: "/rvu/add", element: <AddRvu /> },
  { path: "/rvu/edit/:rvuCode", element: <EditRvu /> },
  { path: "/rvu/view/:rvuCode", element: <EditRvu /> },
  { path: "/rvu/history/:rvuCode", element: <RvuHistory /> },

  { path: "/physician", element: <PhysicianTable /> },
  { path: "/physician/add", element: <PhysicianEnrollmentForm /> },
  // { path: "/physician/edit/:physicianId", element: <EditPhysician /> },
  {
    path: "/physician/edit/:physicianId",
    element: <PhysicianEnrollmentForm />,
  },
  { path: "/physician/view/:physicianId", element: <ViewPhysician /> },
  { path: "/physician/history/:physicianId", element: <RvuHistory /> },
  { path: "/physician-batch-upload", element: <PhysicianBatchUploadPage /> },
  {
    path: "/history-physician-batch-upload",
    element: <PhysicianBatchUploadHistoryPage />,
  },
  {
    path: "/processed-physician-batch-upload",
    element: <PhysicianBatchUploadProcessedPage />,
  },
  {
    path: "/processed-physician-batch-upload/:uploadId",
    element: <PhysicianBatchUploadProcessedPage />,
  },

  {
    path: "/hris-redirect",
    element: (
      <div className="p-6">
        <div className="max-w-3xl">
          <div className="bg-white shadow-md rounded-2xl p-6 border border-gray-200">
            <h2 className="text-2xl font-bold text-gray-800 mb-2 flex items-center gap-2">
              📅 Leaves, Overtime & Undertime Requests
            </h2>
            <p className="text-gray-600 mb-4">
              This feature has been migrated to our{" "}
              <span className="font-semibold text-2xl">New HRIS System</span>.
              All{" "}
              <span className="font-medium">
                leave applications, overtime (OT), and undertime (UT) requests
              </span>{" "}
              are now processed through the integrated human resource platform.
            </p>

            <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 mb-6">
              <h3 className="text-lg font-semibold text-emerald-700 mb-2">
                How to Access the New System
              </h3>
              <p className="text-sm text-emerald-800 leading-relaxed">
                All employees can now file their{" "}
                <span className="font-medium">
                  leaves, overtime (OT), and undertime (UT) requests
                </span>{" "}
                through our new HRIS system. Simply click the button below or
                visit the direct link. You will need your company credentials to
                log in.
              </p>
            </div>

            <div className="mb-8 p-4 bg-gray-50 rounded-lg border">
              <h4 className="font-semibold text-gray-700 mb-2">
                🔗 Direct Access Link
              </h4>
              <div className="flex items-center gap-3">
                <div className="flex-1 p-3 bg-white border rounded-lg">
                  <code className="text-sm text-gray-700 break-all">
                    https://staging-hris.amaphil.com.ph/login
                  </code>
                </div>
                <button
                  onClick={() =>
                    window.open(
                      "https://staging-hris.amaphil.com.ph/login",
                      "_blank"
                    )
                  }
                  className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-lg font-medium transition-colors flex items-center gap-2"
                >
                  <span>Go to HRIS System</span>
                  <span>↗</span>
                </button>
              </div>
            </div>

            <div className="mb-8">
              <h3 className="text-lg font-semibold text-gray-800 mb-3">
                🔹 Available Features in New HRIS
              </h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <div className="bg-emerald-100 p-1 rounded">
                    <span className="text-emerald-600">✓</span>
                  </div>
                  <div>
                    <span className="font-medium">Leave Applications</span> -
                    File vacation, sick, emergency, and other types of leaves
                    with automated approval workflow.
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="bg-orange-100 p-1 rounded">
                    <span className="text-orange-600">✓</span>
                  </div>
                  <div>
                    <span className="font-medium">Overtime (OT) Requests</span>{" "}
                    - Submit overtime requests with date, hours, and reason.
                    Track approval status in real-time.
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="bg-blue-100 p-1 rounded">
                    <span className="text-blue-600">✓</span>
                  </div>
                  <div>
                    <span className="font-medium">Undertime (UT) Requests</span>{" "}
                    - Request early departure or undertime with proper
                    documentation and supervisor approval.
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="bg-purple-100 p-1 rounded">
                    <span className="text-purple-600">✓</span>
                  </div>
                  <div>
                    <span className="font-medium">Balance Tracking</span> - View
                    your remaining leave credits, OT compensations, and UT
                    records in one dashboard.
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="bg-cyan-100 p-1 rounded">
                    <span className="text-cyan-600">✓</span>
                  </div>
                  <div>
                    <span className="font-medium">
                      Real-time Status Updates
                    </span>{" "}
                    - Get notifications when your requests are approved,
                    rejected, or pending action.
                  </div>
                </li>
              </ul>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
              <div className="bg-white border border-emerald-200 rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-emerald-600">24/7</div>
                <div className="text-sm text-gray-600">Accessibility</div>
                <p className="text-xs text-gray-500 mt-1">
                  Access anytime, anywhere
                </p>
              </div>
              <div className="bg-white border border-blue-200 rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-blue-600">
                  Real-time
                </div>
                <div className="text-sm text-gray-600">Approval Process</div>
                <p className="text-xs text-gray-500 mt-1">
                  Instant status updates
                </p>
              </div>
              <div className="bg-white border border-orange-200 rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-orange-600">Secure</div>
                <div className="text-sm text-gray-600">Encrypted Platform</div>
                <p className="text-xs text-gray-500 mt-1">
                  Company-grade security
                </p>
              </div>
            </div>

            <div className="border-t pt-6">
              <h4 className="font-semibold text-gray-700 mb-3">
                📋 Need Help?
              </h4>
              <div className="text-sm text-gray-600">
                <p className="mb-2">
                  If you encounter any issues accessing the HRIS system:
                </p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Contact your department HR representative</li>
                  <li>
                    Email IT support at{" "}
                    <span className="font-medium">
                      it-support@amaphil.com.ph
                    </span>
                  </li>
                  <li>Check your login credentials with your supervisor</li>
                  <li>
                    Ensure you're connected to the company network if accessing
                    internally
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    ),
  },

  { path: "/extraction-reports", element: <ReportsPage /> },

  // {
  //   path: "/ape-scheduler",
  //   element: (() => {
  //     alert("APE Scheduler page is under construction!");
  //     return null;
  //   })(),
  // },

  // {
  //   path: "/ape-scheduler",
  //   element: (
  //     <>
  //       <h2>APE Scheduler page is under construction!</h2>
  //       <p>
  //         Bago magawa ang APE Scheduler modules, kailangan munang matapos ang
  //         mga sumusunod:
  //       </p>
  //       <ol>
  //         <li>- CORPORATE modules (Initially DONE - For Improvements - Need to add members details on Members Tab View)</li>
  //         <li>- PLAN & COVERAGE SETUP (SOB) modules (On-Going Developement)</li>
  //         <li>- MEMBER modules</li>
  //         <li>- PROVIDER ACCESS (BLOCKING NANG TRANSACTION) modules</li>
  //         <li>- APE Scheduler modules</li>
  //       </ol>
  //     </>
  //   ),
  // },

  // {
  //   path: "/ape-scheduler",
  //   element: (
  //     <div className="p-6">
  //       <div className="max-w-3xl">
  //         <div className="bg-white shadow-md rounded-2xl p-6 border">
  //           <h2 className="text-2xl font-bold text-gray-800 mb-2 flex items-center gap-2">
  //             📑 APE Scheduler
  //           </h2>
  //           <p className="text-gray-600 mb-6">
  //             This page is currently{" "}
  //             <span className="font-semibold text-2xl">under development</span>.
  //             Ang Plan & Coverage module ay bahagi ng mas malaking proseso
  //             papunta sa <span className="font-medium">APE Scheduler</span>.
  //             Bawat step ay kailangang matapos para maging fully functional ang
  //             buong system.
  //           </p>

  //           <ol className="space-y-3">
  //             {/* Step 1 - Corporate */}
  //             <li className="flex items-start gap-3">
  //               <span className="flex h-6 w-6 items-center justify-center rounded-full bg-green-100 text-green-600 font-bold text-sm">
  //                 1
  //               </span>
  //               <span className="text-gray-700">
  //                 <span className="font-medium">Corporate Modules</span> — ✅
  //                 Initially DONE. May{" "}
  //                 <span className="font-medium">Corporate Table List View</span>{" "}
  //                 at <span className="font-medium">Add Members tab</span>.
  //                 (Needs improvements: mas detailed member info view).
  //               </span>
  //             </li>

  //             {/* Step 2 - Plan & Coverage */}
  //             <li className="flex items-start gap-3">
  //               <span className="flex h-6 w-6 items-center justify-center rounded-full bg-yellow-100 text-yellow-600 font-bold text-sm">
  //                 2
  //               </span>
  //               <span className="text-gray-700">
  //                 <span className="font-medium">
  //                   Plan & Coverage Setup (SOB)
  //                 </span>{" "}
  //                 — On-going Development.
  //                 <ul className="list-disc pl-6 mt-1 space-y-1 text-gray-600 text-sm">
  //                   <li>
  //                     ✅ Corporate Table List View with <b>Add New Plan</b>
  //                   </li>
  //                   <li>
  //                     🛠 Comprehensive Viewing of plans, coverages, and benefits
  //                   </li>
  //                   <li>🛠 Edit Module (aligned sa Add New Plan features)</li>
  //                   <li>⏳ Advanced Reports & Analytics (planned)</li>
  //                 </ul>
  //               </span>
  //             </li>

  //             {/* Step 3 - Members */}
  //             <li className="flex items-start gap-3">
  //               <span className="flex h-6 w-6 items-center justify-center rounded-full bg-gray-200 text-gray-600 font-bold text-sm">
  //                 3
  //               </span>
  //               <span className="text-gray-700">
  //                 <span className="font-medium">Member Modules</span> — ⏳
  //                 Pending. Will handle member enrollment, LOA transactions, and
  //                 provider history once Plans & Coverage are stable.
  //               </span>
  //             </li>

  //             {/* Step 4 - Providers */}
  //             <li className="flex items-start gap-3">
  //               <span className="flex h-6 w-6 items-center justify-center rounded-full bg-gray-200 text-gray-600 font-bold text-sm">
  //                 4
  //               </span>
  //               <span className="text-gray-700">
  //                 <span className="font-medium">
  //                   Provider Access (Blocking Transactions)
  //                 </span>{" "}
  //                 — ⏳ Planned. To ensure correct validation and blocking rules
  //                 with hospitals and clinics.
  //               </span>
  //             </li>

  //             {/* Step 5 - APE Scheduler */}
  //             <li className="flex items-start gap-3">
  //               <span className="flex h-6 w-6 items-center justify-center rounded-full bg-gray-200 text-gray-600 font-bold text-sm">
  //                 5
  //               </span>
  //               <span className="text-gray-700">
  //                 <span className="font-medium">APE Scheduler Modules</span> —
  //                 ⏳ Final goal. Dependent sa successful completion ng steps
  //                 1–4.
  //               </span>
  //             </li>
  //           </ol>

  //           {/* Progress bar */}
  //           <div className="mt-6">
  //             <div className="w-full bg-gray-200 rounded-full h-2">
  //               <div
  //                 className="bg-purple-500 h-2 rounded-full"
  //                 style={{ width: "60%" }}
  //               ></div>
  //             </div>
  //             <p className="text-sm text-gray-500 mt-2">
  //               Progress: 60% Complete
  //             </p>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   ),
  // },

  // {
  //         id: "ape-scheduler",
  //         title: "APE Scheduler",
  //         icon: "⏰", // Clock/Alarm - represents scheduling
  //         color: "from-blue-500 to-cyan-600",
  //         iconColor: "text-blue-600",
  //         subItems: [
  //           {
  //             id: "ape-scheduler-setup",
  //             to: "/ape-scheduler-setup",
  //             title: "APE Scheduler Setup",
  //             icon: "🛠️", // Tools for setup
  //             iconColor: "text-cyan-500",
  //           },
  //           {
  //             id: "ape-pdf-history",
  //             to: "/ape-pdf-history",
  //             title: "APE Generated PDF History",
  //             icon: "📑", // Document set for history
  //             iconColor: "text-blue-400",
  //           },
  //         ],
  //       }

  { path: "/ape-scheduler-setup", element: <ApeScheduleListPage /> },
  { path: "/ape-scheduler/add", element: <ApeSchedulerPage /> },
  { path: "/ape-scheduler/edit/:setupId", element: <ApeSchedulerEditPage /> },
  { path: "/ape-scheduler/view/:id", element: <ApeScheduleViewer /> },
  { path: "/ape-scheduler/view/:id", element: <ApeScheduleViewer /> },
  { path: "/ape-pdf-history", element: <ApePdfHistoryPage /> },

  // auxiliary tools
  {
    path: "/auxiliary-tools",
    element: (
      <div className="p-6">
        <div className="max-w-3xl ">
          <div className="bg-white shadow-md rounded-2xl p-6 border">
            <h2 className="text-2xl font-bold text-gray-800 mb-2 flex items-center gap-2">
              🛠️ Auxiliary Tools
            </h2>
            <p className="text-gray-600 mb-4">
              This page is currently{" "}
              <span className="font-semibold text-2xl">under development</span>.
              Multiple helper utilities and tools will be available here soon.
            </p>

            <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6">
              <h3 className="text-lg font-semibold text-blue-700 mb-2">
                Ano ang Auxiliary Tools?
              </h3>
              <p className="text-sm text-blue-800 leading-relaxed">
                Ang <span className="font-medium">auxiliary tools</span> ay mga
                karagdagang kagamitan o kasangkapan na ginagamit para suportahan
                ang pangunahing gawain, proseso, o system. Hindi sila ang main
                system, pero nakakatulong sila para mas mabilis, mas maayos, at
                mas ligtas ang trabaho.
              </p>
            </div>

            <h3 className="text-lg font-semibold text-gray-800 mb-3">
              🔹 Halimbawa sa Software Development
            </h3>
            <ul className="space-y-2 text-gray-700 mb-6 list-disc pl-5">
              <li>
                <span className="font-medium">Code Formatter</span> — para
                panatilihin ang malinis at standard na coding style.
              </li>
              <li>
                <span className="font-medium">Debugger</span> — pantulong para
                mabilis mahanap ang errors o bugs.
              </li>
              <li>
                <span className="font-medium">Monitoring Tools</span> — para
                masubaybayan ang performance ng system.
              </li>
              <li>
                <span className="font-medium">API Tester</span> — mabilis na
                paraan para i-check ang mga endpoints.
              </li>
              <li>
                <span className="font-medium">Custom Reports Request</span> —
                pantulong para mabilis ang pag download or pag export nang
                kaylangan na data.
              </li>
            </ul>

            <div className="mt-6">
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-indigo-500 h-2 rounded-full"
                  style={{ width: "0.999999%" }}
                ></div>
              </div>
              <p className="text-sm text-gray-500 mt-2">
                Progress: 0.999999% Complete
              </p>
            </div>
          </div>
        </div>
      </div>
    ),
  },

  // {
  //   path: "/members",
  //   element: (
  //     <div className="p-6">
  //       <div className="max-w-3xl ">
  //         <div className="bg-white shadow-md rounded-2xl p-6 border">
  //           <h2 className="text-2xl font-bold text-gray-800 mb-2 flex items-center gap-2">
  //             👥 Members
  //           </h2>
  //           <p className="text-gray-600 mb-4">
  //             This page is currently{" "}
  //             <span className="font-semibold text-2xl">under development</span>.
  //             Soon, you will be able to view and manage{" "}
  //             <span className="font-medium">corporate members</span> and their{" "}
  //             <span className="font-medium">LOA transactions</span> with our
  //             hospital and clinic partners.
  //           </p>

  //           <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-6">
  //             <h3 className="text-lg font-semibold text-green-700 mb-2">
  //               Ano ang Members Module?
  //             </h3>
  //             <p className="text-sm text-green-800 leading-relaxed">
  //               Ang <span className="font-medium">members module</span> ay para
  //               sa pamamahala ng mga empleyado o dependents ng isang kumpanya na
  //               naka-enroll sa system. Dito nakalista ang kanilang impormasyon,
  //               status, at access sa mga{" "}
  //               <span className="font-medium">healthcare providers</span> kung
  //               saan pwede silang mag-avail ng{" "}
  //               <span className="font-medium">
  //                 LOA (Letter of Authorization)
  //               </span>{" "}
  //               para sa medical services.
  //             </p>
  //           </div>

  //           <h3 className="text-lg font-semibold text-gray-800 mb-3">
  //             🔹 Expected Features
  //           </h3>
  //           <ul className="space-y-2 text-gray-700 mb-6 list-disc pl-5">
  //             <li>
  //               <span className="font-medium">Member Enrollment</span> —
  //               pagdagdag ng corporate employees at dependents.
  //             </li>
  //             <li>
  //               <span className="font-medium">Member Profile</span> — personal
  //               at medical-related details ng bawat member.
  //             </li>
  //             <li>
  //               <span className="font-medium">LOA Requests & Status</span> —
  //               application, approval, at monitoring ng LOA transactions.
  //             </li>
  //             <li>
  //               <span className="font-medium">Provider History</span> — records
  //               ng mga hospital o clinic visits ng members.
  //             </li>
  //             <li>
  //               <span className="font-medium">Reports & Analytics</span> —
  //               summaries tungkol sa usage ng benefits at LOA claims.
  //             </li>
  //           </ul>

  //           <div className="mt-6">
  //             <div className="w-full bg-gray-200 rounded-full h-2">
  //               <div
  //                 className="bg-green-500 h-2 rounded-full"
  //                 style={{ width: "0.99999%" }}
  //               ></div>
  //             </div>
  //             <p className="text-sm text-gray-500 mt-2">
  //               Progress: 0.99999% Complete
  //             </p>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   ),
  // },

  // {
  //   path: "/plan-and-coverage-benefits-view",
  //   element: (
  //     <div className="p-6">
  //       <div className="max-w-3xl ">
  //         <div className="bg-white shadow-md rounded-2xl p-6 border">
  //           <h2 className="text-2xl font-bold text-gray-800 mb-2 flex items-center gap-2">
  //             📑 Plan & Coverage Viewing
  //           </h2>
  //           <p className="text-gray-600 mb-4">
  //             This page is currently{" "}
  //             <span className="font-semibold text-2xl">under development</span>. Only{" "}
  //             <span className="font-medium">administrators or privileged users</span>{" "}
  //             will be able to view and review{" "}
  //             <span className="font-medium">plan setups and coverage benefits</span>{" "}
  //             for proper configuration and assignment to members.
  //           </p>

  //           <div className="bg-purple-50 border border-purple-200 rounded-xl p-4 mb-6">
  //             <h3 className="text-lg font-semibold text-purple-700 mb-2">
  //               Ano ang Plan & Coverage Viewing?
  //             </h3>
  //             <p className="text-sm text-purple-800 leading-relaxed">
  //               Ang module na ito ay ginagamit ng{" "}
  //               <span className="font-medium">admins</span> para makita at suriin
  //               ang mga <span className="font-medium">healthcare plans, benefits,
  //               limits, at exclusions</span> bago ito ma-assign sa mga{" "}
  //               <span className="font-medium">corporate members</span>.
  //               Hindi ito accessible ng mga regular members para mapanatili ang{" "}
  //               <span className="font-medium">data integrity at security</span>.
  //             </p>
  //           </div>

  //           <h3 className="text-lg font-semibold text-gray-800 mb-3">
  //             🔹 Expected Features
  //           </h3>
  //           <ul className="space-y-2 text-gray-700 mb-6 list-disc pl-5">
  //             <li>
  //               <span className="font-medium">Plan Setup Review</span> — makita ang
  //               detalyadong plan packages na available.
  //             </li>
  //             <li>
  //               <span className="font-medium">Benefit Limits</span> — breakdown ng
  //               covered services at corresponding limits.
  //             </li>
  //             <li>
  //               <span className="font-medium">Exclusions</span> — malinaw na listahan
  //               kung ano ang hindi kasama sa plan.
  //             </li>
  //             <li>
  //               <span className="font-medium">Coverage Comparison</span> — para
  //               maikumpara ang iba't ibang plans bago i-assign.
  //             </li>
  //             <li>
  //               <span className="font-medium">Admin-only Access Control</span> —
  //               tanging may tamang role/privilege lang ang makaka-view.
  //             </li>
  //           </ul>

  //           <div className="mt-6">
  //             <div className="w-full bg-gray-200 rounded-full h-2">
  //               <div
  //                 className="bg-purple-500 h-2 rounded-full"
  //                 style={{ width: "0.99999%" }}
  //               ></div>
  //             </div>
  //             <p className="text-sm text-gray-500 mt-2">
  //               Progress: 0.99999% Complete
  //             </p>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   ),
  // },

  { path: "/members", element: <MemberTable /> },
  { path: "/members/add", element: <AddMemberForm /> },
  { path: "/members/edit/:memberId", element: <EditMemberForm /> },
  { path: "/members/view/full-page", element: <MemberViewFullPage /> },
  { path: "/member-employee-id-generator", element: <EmployeeIdGeneratorPage /> },

  { path: "/member-batch-enrollment", element: <UploadMemberEnrollment /> },
  {
    path: "/history-member-batch-enrollment",
    element: <UploadMemberEnrollmentHistory />,
  },
  {
    path: "/processed-member-batch-enrollment",
    element: <MemberEnrollmentProcessedHistory />,
  },
  { path: "/member-batch-renewal-upload", element: <BatchRenewalUploadPage /> },
  {
    path: "/history-member-batch-renewal-upload",
    element: <BatchRenewalUploadHistoryPage />,
  },
  {
    path: "/processed-member-batch-renewal-upload",
    element: <BatchRenewalUploadProcessedPage />,
  },
  {
    path: "/processed-member-batch-renewal-upload/:uploadId",
    element: <BatchRenewalUploadProcessedPage />,
  },
  { path: "/member-batch-change-plan-upload", element: <BatchChangePlanUploadPage /> },
  {
    path: "/history-member-batch-change-plan-upload",
    element: <BatchChangePlanUploadHistoryPage />,
  },
  {
    path: "/processed-member-batch-change-plan-upload",
    element: <BatchChangePlanUploadProcessedPage />,
  },
  {
    path: "/processed-member-batch-change-plan-upload/:uploadId",
    element: <BatchChangePlanUploadProcessedPage />,
  },
  {
    path: "/member-batch-text-alert-mobile-update-upload",
    element: <BatchTextAlertMobileUpdateUploadPage />,
  },
  {
    path: "/history-member-batch-text-alert-mobile-update-upload",
    element: <BatchTextAlertMobileUpdateUploadHistoryPage />,
  },
  {
    path: "/processed-member-batch-text-alert-mobile-update-upload",
    element: <BatchTextAlertMobileUpdateUploadProcessedPage />,
  },
  {
    path: "/processed-member-batch-text-alert-mobile-update-upload/:uploadId",
    element: <BatchTextAlertMobileUpdateUploadProcessedPage />,
  },
  { path: "/member-batch-activation-upload", element: <BatchActivationUploadPage /> },
  {
    path: "/history-member-batch-activation-upload",
    element: <BatchActivationUploadHistoryPage />,
  },
  {
    path: "/processed-member-batch-activation-upload",
    element: <BatchActivationUploadProcessedPage />,
  },
  {
    path: "/processed-member-batch-activation-upload/:uploadId",
    element: <BatchActivationUploadProcessedPage />,
  },
  { path: "/member-batch-deactivation-upload", element: <BatchDeactivationUploadPage /> },
  {
    path: "/history-member-batch-deactivation-upload",
    element: <BatchDeactivationUploadHistoryPage />,
  },
  {
    path: "/processed-member-batch-deactivation-upload",
    element: <BatchDeactivationUploadProcessedPage />,
  },
  {
    path: "/processed-member-batch-deactivation-upload/:uploadId",
    element: <BatchDeactivationUploadProcessedPage />,
  },

  { path: "/corporate", element: <CorporateTable /> },
  { path: "/corporate/add", element: <CorporateEnrollmentForm /> },
  { path: "/corporate/add-fund/:corpCode", element: <CorporateAddFundPage /> },
  { path: "/corporate/edit/:corpCode", element: <CorporateEnrollmentForm /> },
  { path: "/corporate/view/:corpCode", element: <CorporateViewModal /> },
  // { path: "/corporate/history/:corpCode", element: <RvuHistory /> },

  {
    path: "/plan-and-coverage-benefits-setup",
    element: <PlanAndCoverageBenefitsTable />,
  },
  {
    path: "/plan-and-coverage-benefits-setup/add/:corpCode",
    element: <AddPlanForm />,
  },
  {
    path: "/plan-and-coverage-benefits-setup/edit/:corpCode/:planCode",
    element: <EditPlanForm />,
  },
  // { path: "/plan-and-coverage-benefits-setup/add/:corpCode", element: <PlanForm /> },

  // { path: "/plan-and-coverage/:corpCode", element: <CorporatePlansTable /> },
  { path: "/plan-and-coverage/:corpCode", element: <PlanCoverageViewer /> },
  { path: "/plan-and-coverage-benefits-view", element: <PlanCoverageViewer /> },

  {
    path: "/ref-master-table-list/ref-coverage-master",
    element: <RefCoverageMaster />,
  },
  {
    path: "/ref-master-table-list/ref-benefit-master",
    element: <RefCoverageMaster />,
  },

  // BANNERS ALERT MODULES
  { path: "/banners", element: <BannerTable /> },
  { path: "/banners/add", element: <AddBannerForm /> },
  { path: "/banners/edit/:id", element: <EditBannerForm /> },

  { path: "/provider-access", element: <ProviderAccessPage /> },

  {
    path: "/ai-assistant",
    element: (
      <div className="p-6">
        <div className="max-w-3xl">
          <div className="bg-white shadow-md rounded-2xl p-6 border">
            <h2 className="text-2xl font-bold text-gray-800 mb-2 flex items-center gap-2">
              🤖 AI Assistant
            </h2>
            <p className="text-gray-600 mb-6">
              This page is currently{" "}
              <span className="font-semibold text-2xl">under development</span>.
              Ang AI Assistant ay gagamitin para{" "}
              <span className="font-medium">maka-search ng data</span> at
              makapagbigay ng{" "}
              <span className="font-medium">intelligent responses</span> batay
              sa laman ng database.
            </p>

            <ol className="space-y-3">
              {/* Step 1 - Database */}
              <li className="flex items-start gap-3">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-green-100 text-green-600 font-bold text-sm">
                  1
                </span>
                <span className="text-gray-700">
                  <span className="font-medium">
                    Database Indexing & Optimization
                  </span>{" "}
                  — ✅ Nakahanda na ang initial schema. Next step: i-optimize
                  para sa mabilis na querying.
                </span>
              </li>

              {/* Step 2 - API */}
              <li className="flex items-start gap-3">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-yellow-100 text-yellow-600 font-bold text-sm">
                  2
                </span>
                <span className="text-gray-700">
                  <span className="font-medium">API Endpoints</span> — 🛠
                  On-going development. Ito ang magiging bridge ng AI Assistant
                  sa database.
                </span>
              </li>

              {/* Step 3 - Chatbot UI */}
              <li className="flex items-start gap-3">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-gray-200 text-gray-600 font-bold text-sm">
                  3
                </span>
                <span className="text-gray-700">
                  <span className="font-medium">Chatbot UI/UX</span> — ⏳
                  Planned. Magkakaroon ng conversational interface na parang
                  messenger/chat app.
                </span>
              </li>

              {/* Step 4 - AI/NLP Integration */}
              <li className="flex items-start gap-3">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-gray-200 text-gray-600 font-bold text-sm">
                  4
                </span>
                <span className="text-gray-700">
                  <span className="font-medium">AI & NLP Integration</span> — ⏳
                  Planned. Gagamit ng NLP model para makaintindi ng tanong at
                  makapagbigay ng intelligent responses.
                </span>
              </li>

              {/* Step 5 - Security */}
              <li className="flex items-start gap-3">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-gray-200 text-gray-600 font-bold text-sm">
                  5
                </span>
                <span className="text-gray-700">
                  <span className="font-medium">Security & Access Control</span>{" "}
                  — ⏳ Planned. Para maiwasan unauthorized queries at data
                  leaks.
                </span>
              </li>
            </ol>

            {/* Progress bar */}
            <div className="mt-6">
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-blue-500 h-2 rounded-full"
                  style={{ width: "0.99%" }}
                ></div>
              </div>
              <p className="text-sm text-gray-500 mt-2">
                Progress: 0.99% Complete
              </p>
            </div>

            {/* Future Chat UI Preview */}
            <div className="mt-8 bg-gray-50 border rounded-xl p-4">
              <p className="text-gray-600 mb-3 font-medium">💬 Preview:</p>
              <div className="space-y-3">
                <div className="bg-blue-100 text-blue-800 p-3 rounded-lg w-fit">
                  User: "Hanapin mo lahat ng pending transactions"
                </div>
                <div className="bg-gray-100 text-gray-700 p-3 rounded-lg w-fit">
                  AI Assistant: "Mayroong 12 pending transactions sa database."
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ),
  },

  // activity-log
  { path: "/activity-logs", element: <ActivityLogs /> },

  // Vector Database Context Route
  {
    path: "/vector-database",
    element: (
      <div className="p-6">
        <div className="max-w-4xl">
          <div className="bg-white shadow-md rounded-2xl p-6 border">
            <h2 className="text-2xl font-bold text-gray-800 mb-2 flex items-center gap-2">
              🗄️ Vector Database Implementation
            </h2>
            <p className="text-gray-600 mb-4">
              This section is currently{" "}
              <span className="font-semibold text-2xl">under development</span>.
              We're implementing vector-based search for faster and more
              accurate queries.
            </p>

            <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6">
              <h3 className="text-lg font-semibold text-blue-700 mb-2">
                What is a Vector Database?
              </h3>
              <p className="text-sm text-blue-800 leading-relaxed">
                A <span className="font-medium">vector database</span> is a
                specialized database that stores data as mathematical vectors in
                high-dimensional space. It enables lightning-fast similarity
                searches and is perfect for AI-powered applications,
                recommendation systems, and semantic search.
              </p>
            </div>

            <h3 className="text-lg font-semibold text-gray-800 mb-3">
              🔹 Key Benefits in Our Implementation
            </h3>
            <ul className="space-y-2 text-gray-700 mb-6 list-disc pl-5">
              <li>
                <span className="font-medium">
                  High-Speed Similarity Search
                </span>{" "}
                — Find similar items in milliseconds using mathematical vector
                comparisons.
              </li>
              <li>
                <span className="font-medium">Semantic Understanding</span> —
                Understands the meaning and context behind queries, not just
                keyword matching.
              </li>
              <li>
                <span className="font-medium">AI-Powered Queries</span> —
                Perfect for machine learning models and natural language
                processing.
              </li>
              <li>
                <span className="font-medium">Scalable Performance</span> —
                Handles millions of vectors while maintaining fast query times.
              </li>
              <li>
                <span className="font-medium">Enhanced User Experience</span> —
                Provides more accurate and relevant search results.
              </li>
            </ul>

            <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-6">
              <h3 className="text-lg font-semibold text-green-700 mb-2">
                🚀 Technical Implementation
              </h3>
              <div className="text-sm text-green-800 leading-relaxed">
                <p className="mb-2">
                  <strong>Architecture:</strong> We're using a hybrid approach
                  combining traditional databases with vector indexing for
                  optimal performance.
                </p>
                <p className="mb-2">
                  <strong>Embedding Model:</strong> Converting text and data
                  into 384-dimensional vectors for semantic understanding.
                </p>
                <p>
                  <strong>Search Algorithm:</strong> Cosine similarity with
                  approximate nearest neighbor search for blazing-fast results.
                </p>
              </div>
            </div>

            <h3 className="text-lg font-semibold text-gray-800 mb-3">
              📊 Planned Features
            </h3>
            <ul className="space-y-2 text-gray-700 mb-6 list-disc pl-5">
              <li>Real-time vector indexing and search</li>
              <li>Multi-modal support (text, images, audio)</li>
              <li>Hybrid search (vector + keyword)</li>
              <li>Automated embedding generation</li>
              <li>Performance monitoring dashboard</li>
            </ul>

            <div className="mt-6">
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-indigo-500 h-2 rounded-full transition-all duration-500"
                  style={{ width: "0.9999999%" }}
                ></div>
              </div>
              <p className="text-sm text-gray-500 mt-2">
                Development Progress: 0.9999999% Complete
              </p>
              <p className="text-xs text-gray-400 mt-1">
                Current Phase: Vector Indexing Infrastructure
              </p>
            </div>
          </div>
        </div>
      </div>
    ),
  },

  // System Users Management Route
  {
    path: "/system-users",
    element: <SystemUsers />,
  },

  // System Settings V2 Route
  {
    path: "/system-settings-v2",
    element: <SystemSettingsV2 />,
  },

  // Upload S3 Public Share Token Management Route
  {
    path: "/system-admin/upload-s3-public-share-token",
    element: <UploadS3PublicShareTokenPage />,
  },
  {
    path: "/system-admin/curl-request-response-logs",
    element: <CurlRequestResponseLogsPage />,
  },

  { path: "/change-logs", element: <ChangelogPage /> },
  { path: "/messages", element: <MessagesPage /> },

  // Transaction Modules
  { path: "/transactions", element: <TransactionList /> },
  { path: "/transactions/:transNo/details", element: <TransactionDetailsPage /> },
  { path: "/transactions/loa-issuer-lookup", element: <LoaIssuerLookupPage /> },
  { path: "/generate-loa-transaction", element: <GenerateLoaTransaction /> },
  { path: "/loa-pdf-generation-specs", element: <LoaPdfGenerationSpecsPage /> },
  { path: "/tracker", element: <TrackerPage /> },

  {
    path: "/transaction-verification",
    element: <AdmissionVerificationTable />,
  },
  {
    path: "/transaction-discharge",
    element: <AdmissionDischargeTable />,
  },
  {
    path: "/transaction-reimbursement-list",
    element: <ReimbursementList />,
  },
  {
    path: "/transaction-reimbursement-add",
    element: <ReimbursementAdd />,
  },
  {
    path: "/transaction-reimbursement-dpr",
    element: <DetailedPaymentReportPage />,
  },
  {
    path: "/transaction-reimbursement-dpr-all",
    element: <DetailedPaymentReportAllPage />,
  },
  {
    path: "/transaction-reimbursement-dpr/full-view",
    element: <DetailedPaymentReportFullViewPage />,
  },
  {
    path: "/transaction-reimbursement-dpr-all/full-view",
    element: <DetailedPaymentReportFullViewPage />,
  },
  {
    path: "/batch-add-holiday-list",
    element: <BatchAddHolidayListPage />,
  },
  {
    path: "/batch-add-holiday-upload",
    element: <BatchAddHolidayUploadPage />,
  },
  {
    path: "/history-batch-add-holiday-upload",
    element: <BatchAddHolidayUploadHistoryPage />,
  },
  {
    path: "/processed-batch-add-holiday-upload",
    element: <BatchAddHolidayUploadProcessedPage />,
  },
  {
    path: "/processed-batch-add-holiday-upload/:uploadId",
    element: <BatchAddHolidayUploadProcessedPage />,
  },
  {
    path: "/dpr-validation-upload",
    element: <DprUploadValidationCsvPage />,
  },
  {
    path: "/dpr-validation-dashboard",
    element: <DprValidationDashboardPage />,
  },
  {
    path: "/dpr-validation-upload-history",
    element: <DprUploadValidationCsvHistoryPage />,
  },
  {
    path: "/dpr-validation-upload-processed",
    element: <DprUploadValidationCsvProcessedPage />,
  },
  {
    path: "/dpr-validation-upload-ai-summary-history",
    element: <DprUploadValidationAiSummaryHistoryPage />,
  },
  {
    path: "/dpr-validation-support",
    element: <DprValidationSupportPage />,
  },
  { path: "/settlement-list", element: <SettlementListPage /> },
  { path: "/settlement-history", element: <SettlementHistoryPage /> },
  {
    path: "/settlement-batch-print-pis-form2307",
    element: <BatchPrintPisAndForm2307Page />,
  },
  {
    path: "/provider-delivery-address-label",
    element: <ProviderDeliveryAddressLabelPage />,
  },
  {
    path: "/find-data-using-prn",
    element: <FindDataUsingPrnPage />,
  },
  {
    path: "/credit-file",
    element: <CreditFilePage />,
  },
  {
    path: "/provider-bank-validation",
    element: <ProviderBankValidationPage />,
  },
  { path: "/credit-advise", element: <CreditAdviseUploadPage /> },
  { path: "/credit-advise-history", element: <CreditAdviseUploadHistoryPage /> },
  { path: "/credit-advise-processed/:uploadId", element: <CreditAdviseUploadProcessedPage /> },
  { path: "/settlement-email-outbox", element: <SettlementEmailOutboxPage /> },

    { path: "/settlement-batch-upload", element: <SettlementBatchUploadPage /> },
    { path: "/settlement-batch-upload-history", element: <SettlementBatchUploadHistoryPage /> },
    { path: "/settlement-batch-upload-processed/:uploadId", element: <SettlementBatchUploadProcessedPage /> },
    { path: "/batch-regenerate-pis-form2307", element: <SettlementPdfRegenerationBatchUploadPage /> },
    { path: "/batch-regenerate-pis-form2307-history", element: <SettlementPdfRegenerationBatchHistoryPage /> },
    { path: "/batch-regenerate-pis-form2307-processed/:uploadId", element: <SettlementPdfRegenerationBatchProcessedPage /> },
    { path: "/check-status-batch-upload", element: <CheckStatusBatchUploadPage /> },
    { path: "/check-status-batch-upload-history", element: <CheckStatusBatchUploadHistoryPage /> },
    { path: "/check-status-batch-upload-processed/:uploadId", element: <CheckStatusBatchUploadProcessedPage /> },
    { path: "/deposit-slip-batch-upload", element: <DepositSlipBatchUploadPage /> },
    { path: "/deposit-slip-batch-upload-history", element: <DepositSlipBatchUploadHistoryPage /> },
    { path: "/deposit-slip-batch-upload-processed/:uploadId", element: <DepositSlipBatchUploadProcessedPage /> },
    { path: "/depo-or-batch-upload", element: <DepoOrBatchUploadPage /> },
    { path: "/depo-or-batch-upload-history", element: <DepoOrBatchUploadHistoryPage /> },
    { path: "/depo-or-batch-upload-processed/:uploadId", element: <DepoOrBatchUploadProcessedPage /> },

  { path: "/process-discharge/:transNo", element: <ProcessDischargePage /> },



  { path: "/google-sign-in-sample", element: <GoogleSignInButton /> },

  // BACKEND
  { path: "/backend/specs", element: <BackendModuleSpecsPage /> },
  { path: "/backend", element: <BackendModulePage /> },
  { path: "/backend-logs", element: <BackendLogsPage /> },
  { path: "/extract-claims-logs", element: <ExtractClaimsLogsPage /> },
  { path: "/queries", element: <QueriesPlaceholderPage /> },

  // SYSTEM ADMIN LEGACY ALIASES
  { path: "/system-admin/backend/specs", element: <BackendModuleSpecsPage /> },
  { path: "/system-admin/backend", element: <BackendModulePage /> },
  { path: "/system-admin/backend-logs", element: <BackendLogsPage /> },
  { path: "/system-admin/extract-claims-logs", element: <ExtractClaimsLogsPage /> },
  { path: "/system-admin/dynamic-table-update", element: <DynamicTableUpdatePage /> },
];

export const protectedRoutes = baseProtectedRoutes.map((route) => {
  const requiredScopes =
    route.requiredScopes ?? getRequiredScopesForPath(route.path);
  return {
    ...route,
    element: (
      <ScopeProtectedRoute requiredScopes={requiredScopes}>
        {route.element}
      </ScopeProtectedRoute>
    ),
  };
});

// Permission-Protected Routes
export const permissionRoutes = [
  // { path: "/chatbot-queuing", element: <ChatbotQueuing />, permission: "access_page" },
  // { path: "/analytics", element: <Analytics />, permission: "access_page" },
  // Add more permission-based routes as needed based on your sample
  // Example:
  // { path: "/settings", element: <Settings />, permission: "delete_page" },
].map((route) => ({
  ...route,
  element: (
    <PermissionProtectedRoute requiredPermission={route.permission}>
      {route.element}
    </PermissionProtectedRoute>
  ),
}));



